/** @type {import('tailwindcss').Config} */
module.exports = {
  content: ['./src/**/*.{ts,tsx}'],
  theme: {
    extend: {
      colors: {
        error: {
          DEFAULT: '#f44336',
          contrast: '#ffffff',
          light: '#ffebee',
          dark: '#b71c1c',
        },
        success: {
          DEFAULT: '#4caf50',
          contrast: '#ffffff',
          light: '#e8f5e9',
          dark: '#1b5e20',
        },
        info: {
          DEFAULT: '#38bdf8',
          contrast: '#ffffff',
          light: '#f0f9ff',
          dark: '#01579b',
        },
        warning: {
          DEFAULT: '#ffc107',
          contrast: '#ffffff',
          light: '#fffde7',
          dark: '#98794c',
        },
      },
    },
  },
  plugins: [],
};
